import {Component, Input, isDevMode, OnChanges, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Config} from '../../models/config';
import {FindInvalidControlsService} from '../../services/find-invalid-controls.service';

@Component({
  selector: 'storever-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnChanges {

  @Input() config: Config[];
  @Input() form: FormGroup;
  @Input() isAdd: boolean;
  @Input() isEdit: boolean;
  @Input() isExchange: boolean;
  @Input() isLoadingBlock: boolean;
  @Input() orderType: number;
  @Input() stylingClass: string;

  constructor(private findInvalidControlsService: FindInvalidControlsService) {}

  ngOnChanges(changes: SimpleChanges): void {}

  getInvalidControls(form: FormGroup): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }

  get inputConfig(): Config[] {
    return this.config;
  }

  UpdateLoading(value: boolean): void {
    this.isLoadingBlock = value;
  }
}
